import { render } from "./App.vue?vue&type=template&id=23c5944e&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=23c5944e&lang=scss&scoped=true"

import exportComponent from "/Users/liming/jenkins/jenkins/workspace/an-plus-frontend-monorepo-prod/projects-mobile/property/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c5944e"]])

export default __exports__